import script from "./statisticsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./statisticsTable.vue?vue&type=script&setup=true&lang=js"

import "./statisticsTable.vue?vue&type=style&index=0&id=58077988&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58077988"]])

export default __exports__